// extracted by mini-css-extract-plugin
module.exports = {"box":"_3njQw","avatar":"CNj9g","name":"_3-Thz","desc":"_3csU2","close":"_1P5fO"};